/**
 * bootClientPolish — Keybinds + settings + ping HUD (SPY-113 / SPY-213 / SPY-214).
 */

import { bootLiveKeybindings } from './bootLiveKeybindings.js';
import { wireSettingsPanel } from './wireSettingsPanel.js';
import { wirePingHud } from './wirePingHud.js';
import { wireMatchEndHonor } from './wireMatchEndHonor.js';

/**
 * @param {object} deps
 * @returns {{ remaps: object, pingHud: object, tickPingHud: (dt: number) => void }}
 */
export function bootClientPolish({
  scoreboardWire,
  abilityCast,
  summonerSpellWire,
  inputController,
  onToggleRange
} = {}) {
  const { remaps } = bootLiveKeybindings({
    scoreboardWire,
    abilityCast,
    summonerSpellWire,
    inputController,
    onToggleRange
  });
  wireSettingsPanel({ remapsApi: remaps });
  const pingHud = wirePingHud();
  const honorHud = wireMatchEndHonor();
  return {
    remaps,
    pingHud,
    honorHud,
    tickPingHud: (dt) => pingHud.tick(dt)
  };
}
